import React from 'react'
import type {
  KambiSportsEventDetails,
  KambiSportsSameGameMultiSelection,
} from '@mobi/betslip/types'
import { Icon } from '@mobi/component-library/Common/Icon/Icon'
import { Flex } from '@mobi/component-library/Common/Flex'
import { spacing } from '@mobi/component-library/Theme/Common'
import { EventInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/EventInfo'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'
import { getSelectionNameFromKambiBetOffer } from '@core/Areas/Quickbet/helpers/selectionsKambi'

export const KambiSportsHeaderSameGameMulti: React.FC<{
  selection: KambiSportsSameGameMultiSelection
  eventDetails: KambiSportsEventDetails
}> = ({ selection, eventDetails }) => {
  return (
    <Flex flexDirection='column' gap={spacing.sm}>
      <EventInfo
        icon={<Icon type='tab' size='2.2rem' />}
        eventInfo={eventDetails.events[0].englishName}
      />

      <SecondaryInfo
        marketInfo={`${selection.betOffers.length} Leg Same Game Multi`}
        eventStart={eventDetails.events[0].start}
      />

      <Flex flexDirection='column' gap={spacing.smx1}>
        {selection.betOffers.map(betOffer => (
          <SelectionInfo
            key={betOffer.id}
            leftSlot={
              <div
                style={{
                  width: '3rem',
                  height: '3rem',
                  borderRadius: '50%',
                  background: '#47245D',
                  flexShrink: 0,
                }}
              />
            }
            text={getSelectionNameFromKambiBetOffer(betOffer)}
            subText={betOffer.criterion.label}
          />
        ))}
      </Flex>
    </Flex>
  )
}
